const PREFIX = 'CONFIRM_EMPLOYEE'

export const CONFIRM_EMPLOYEE_PAGE_REQUEST = `${PREFIX}_PAGE_REQUEST`

export const CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT = `${PREFIX}_CREATE_EMPLOYEE_ACCOUNT`

export const CONFIRM_EMPLOYEE_INVALID_INVITATION = `${PREFIX}_INVALID_INVITATION`

export const CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE = `${PREFIX}_SET_INVITED_EMPLOYEE`



// WEBPACK FOOTER //
// ./app/actions/confirmEmployee/constants.js